export const gender = ["Male", "Female", "Other"];
export default gender;
